<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <!-- Dashboard Header -->
      <div class="card card-xl-stretch mb-6">
        <div class="card-body d-flex flex-column px-6">
          <div class="row">
            <div
              *ngFor="let item of dashboardHeaderItems; let last = last"
              class="col-md-3 dashboard-item px-6"
              [ngClass]="{ 'border-end border-2': !last }"
            >
              <div class="flex-grow-1">
                <div class="d-flex align-items-center">
                  <h1 class="text-black fw-bold flex-grow-1 mb-0">
                    <span *ngIf="item.label === 'totalIncome'"> </span>
                    {{ dashboardStatistics[item.countKey] || 0 }}
                  </h1>
                  <div class="symbol">
                    <span class="symbol-label bg-white">
                      <img
                        [src]="item.icon"
                        class="img-fluid"
                        [alt]="item.label"
                      />
                    </span>
                  </div>
                </div>

                <div class="text-gray-900 fw-bold fs-4">
                  {{ item.label | translate }}
                </div>
                <p class="mt-1 fs-14 increase-text">
                  <i
                    class="fa-solid fs-6 me-2"
                    [ngClass]="getArrowStyle(item.increasePercentageLastMonth)"
                  ></i>
                  {{ item.increasePercentageLastMonth.toFixed(1) }}%
                  {{ item.duration | translate }}
                </p>

                <div
                  *ngIf="item.label === 'totalIncome'"
                  class="input-group input-group-sm income-area"
                >
                  <input
                    #priceInput
                    type="number"
                    class="form-control no-spin"
                    [ngClass]="{ 'is-invalid': invalidPriceValue }"
                    [(ngModel)]="priceValue"
                    (keyup.enter)="updateUserPrice(); priceInput.blur()"
                    (input)="validatePrice($event)"
                    step="0.01"
                  />
                  <div *ngIf="invalidPriceValue" class="invalid-feedback">
                    {{ "dashboard.pleaseEnterValidPrice" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts and Statistics -->
      <div class="row">
        <!-- Line Chart -->
        <div class="col-md-8 col-12 mb-md-0 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title mb-4">
                  {{ "dashboard.patientsAndConsultations" | translate }}
                </h4>
                <div class="form-floating">
                  <select
                    [(ngModel)]="selectedChartType"
                    (change)="onChangeChart($event)"
                    class="form-select cursor-pointer"
                    id="inputSelect"
                    aria-label="Select"
                  >
                    <option
                      *ngFor="let item of chartSelectionType"
                      [value]="item.value"
                    >
                      {{ item.label | translate }}
                    </option>
                  </select>
                  <label for="inputSelect">{{
                    "dashboard.selectComboTitle" | translate
                  }}</label>
                </div>
              </div>
              <canvas id="lineChart"></canvas>
            </div>
          </div>
        </div>
        <!-- Statistics -->
        <div class="col-md-4 col-12">
          <div class="row h-100 gap-6">
            <!-- After 3 months -->
            <div class="col-md-12">
              <div class="card h-100">
                <div class="card-body">
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountByThreeMonth ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor3months" | translate }}
                  </p>
                  <div class="progress">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      style="width: 25%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- After 6 months -->
            <div class="col-md-12">
              <div class="card h-100">
                <div class="card-body">
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountBySixMonth ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor6months" | translate }}
                  </p>
                  <div class="progress">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style="width: 50%"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- After 12 months -->
            <div class="col-md-12">
              <div class="card h-100">
                <div class="card-body">
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountByTwelveMonth ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor12months" | translate }}
                  </p>
                  <div class="progress">
                    <div
                      class="progress-bar bg-dark"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Support Center and Images -->
      <div class="row mt-6">
        <!-- Support Center -->
        <div class="col-md-8 mb-md-0 mb-4">
          <div class="card bg-dark text-white h-100">
            <div class="card-body">
              <h2 class="card-title text-white mb-3">
                {{ "dashboard.supportCenter" | translate }}
              </h2>
              <p class="card-text fs-14 mt-4">
                {{ "dashboard.supportCenterDesc" | translate }}
              </p>
              <p class="fw-bold fs-14">
                {{ "dashboard.supportCenterCall" | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Images -->
        <div class="col-md-4">
          <div class="row h-100">
            <div class="col-sm-6 mb-md-0 mb-4">
              <img
                src="./../../../../../assets/media/dashboard/image-1.jpg"
                alt="Image 1"
                class="img-fluid rounded"
              />
            </div>
            <div class="col-sm-6">
              <img
                src="./../../../../../assets/media/dashboard/image-2.png"
                alt="Image 2"
                class="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
